if (!customElements.get('installments-component')) {
  customElements.define('installments-component', class InstallmentsComponent extends HTMLElement {
    constructor() {
      super();
      this.variantId = this.dataset.variantId;
      this.productId = this.dataset.productId;
      this.sectionId = this.dataset.sectionId;
      this.productFormId = this.dataset.productFormId;
      this.roundedPrice = this.dataset.roundedPrice;
      this.installmentPrice = this.dataset.installmentPrice;
      
      this.handleShopPayClick = this.handleShopPayClick.bind(this);
      this.handleKlarnaClick = this.handleKlarnaClick.bind(this);
      this.observeShopPayTerms = this.observeShopPayTerms.bind(this);
      this.observeKlarnaTerms = this.observeKlarnaTerms.bind(this);
      this.hidePaymentElementParent = this.hidePaymentElementParent.bind(this);
      this.onVariantChanged = this.onVariantChanged.bind(this);
    }

    connectedCallback() {
      if (!this.isConnected) return;

      this.shopPayButton = this.querySelector('.shop-pay-button');
      this.klarnaButton = this.querySelector('.klarna-button');
      this.priceElement = this.querySelector('.installments-price span:first-child');

      if (this.shopPayButton) {
        this.shopPayButton.addEventListener('click', this.handleShopPayClick);
      }

      if (this.klarnaButton) {
        this.klarnaButton.addEventListener('click', this.handleKlarnaClick);
      }

      if (this.productFormId) {
        const formElement = document.getElementById(this.productFormId);
        if (formElement) {
          formElement.addEventListener('variant:change', this.onVariantChanged);
        }
      }

      this.setupMutationObservers();
    }

    disconnectedCallback() {
      if (this.shopPayButton) {
        this.shopPayButton.removeEventListener('click', this.handleShopPayClick);
      }

      if (this.klarnaButton) {
        this.klarnaButton.removeEventListener('click', this.handleKlarnaClick);
      }

      if (this.productFormId) {
        const formElement = document.getElementById(this.productFormId);
        if (formElement) {
          formElement.removeEventListener('variant:change', this.onVariantChanged);
        }
      }

      if (this.observer) {
        this.observer.disconnect();
      }
    }

    setupMutationObservers() {
      if (!this.productFormId) {
        this.observeDocumentBody();
        return;
      }

      const formElement = document.getElementById(this.productFormId);
      
      if (!formElement) {
        this.observeDocumentBody();
        return;
      }
      
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            this.findPaymentElements();
          }
        });
      });

      this.observer.observe(formElement, {
        childList: true,
        subtree: true
      });

      this.findPaymentElements();
    }

    observeDocumentBody() {
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            this.findPaymentElements();
          }
        });
      });

      this.observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      this.findPaymentElements();
    }

    findPaymentElements() {
      let shopPayTerms = null;
      let klarnaElement = null;
      
      if (this.productFormId) {
        const formElement = document.getElementById(this.productFormId);
        if (formElement) {
          shopPayTerms = formElement.querySelector('shopify-payment-terms');
          klarnaElement = formElement.querySelector('klarna-placement');
        }
      }
      
      if (!shopPayTerms) {
        shopPayTerms = document.querySelector('shopify-payment-terms');
      }
      if (!klarnaElement) {
        klarnaElement = document.querySelector('klarna-placement');
      }

      if (shopPayTerms && !this.shopPayTermsFound) {
        this.shopPayTermsFound = true;
        this.observeShopPayTerms(shopPayTerms);
      }

      if (klarnaElement && !this.klarnaElementFound) {
        this.klarnaElementFound = true;
        this.observeKlarnaTerms(klarnaElement);
      }
    }

    observeShopPayTerms(shopPayTerms) {
      this.shopPayTerms = shopPayTerms;
      this.hidePaymentElementParent(shopPayTerms);
    }

    observeKlarnaTerms(klarnaElement) {
      this.klarnaElement = klarnaElement;
      this.hidePaymentElementParent(klarnaElement);
    }

    handleShopPayClick() {
      if (this.shopPayTerms) {
        this.hidePaymentElementParent(this.shopPayTerms);
        this.shopPayTerms.click();
        
        if (this.shopPayTerms.shadowRoot) {
          const shopPayButton = this.shopPayTerms.shadowRoot.querySelector('button') || 
                                this.shopPayTerms.shadowRoot.querySelector('[role="button"]') ||
                                this.shopPayTerms.shadowRoot.querySelector('a');
          if (shopPayButton) {
            shopPayButton.click();
          }
        }
      } else {
        this.findPaymentElements();
      }
    }

    handleKlarnaClick() {
      if (this.klarnaElement) {
        this.hidePaymentElementParent(this.klarnaElement);
        this.klarnaElement.click();
        
        if (this.klarnaElement.shadowRoot) {
          const klarnaButton = this.klarnaElement.shadowRoot.querySelector('button') ||
                               this.klarnaElement.shadowRoot.querySelector('[role="button"]') ||
                               this.klarnaElement.shadowRoot.querySelector('a');
          if (klarnaButton) {
            klarnaButton.click();
          }
        } else {
          const clickEvent = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          });
          this.klarnaElement.dispatchEvent(clickEvent);
        }
      } else {
        this.findPaymentElements();
      }
    }

    hidePaymentElementParent(element) {
      if (!element) return;
      
      let parent = element.parentElement;
      while (parent && parent !== document.body) {
        if (parent.classList && (
            parent.classList.contains('product-info__block-item')
        )) {
          const originalPosition = parent.style.position;
          const originalVisibility = parent.style.visibility;
          const originalHeight = parent.style.height;
          const originalWidth = parent.style.width;
          const originalOpacity = parent.style.opacity;
          const originalPointerEvents = parent.style.pointerEvents;

          parent.dataset.originalPosition = originalPosition;
          parent.dataset.originalVisibility = originalVisibility;
          parent.dataset.originalHeight = originalHeight;
          parent.dataset.originalWidth = originalWidth;
          parent.dataset.originalOpacity = originalOpacity;
          parent.dataset.originalPointerEvents = originalPointerEvents;

          parent.style.position = 'absolute';
          parent.style.visibility = 'hidden';
          parent.style.height = '0';
          parent.style.width = '0';
          parent.style.opacity = '0';
          parent.style.pointerEvents = 'none';
          parent.style.overflow = 'hidden';
          
          break;
        }
        parent = parent.parentElement;
      }
    }

    onVariantChanged(event) {
      if (!event.detail.variant || !this.priceElement) return;

      const variantPrice = event.detail.variant.price;
      const installmentPrice = Math.floor(variantPrice / 4);

      this.updateInstallmentPrice(installmentPrice);

      this.dataset.variantId = event.detail.variant.id;
      this.dataset.installmentPrice = installmentPrice;
    }

    updateInstallmentPrice(installmentPrice) {
      if (window.formatMoney) {
        this.priceElement.innerHTML = window.formatMoney(installmentPrice);
      } else if (window.themeVariables && window.themeVariables.formatMoney) {
        this.priceElement.innerHTML = window.themeVariables.formatMoney(installmentPrice);
      } else {
        this.priceElement.innerHTML = `$${(installmentPrice / 100).toFixed(2)}`;
      }
    }
  });
}